import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import HomeFeaturedCircles from "../containers/HomeFeaturedCircles";
import AdvantagesSection from "../containers/AdvantagesSection";
import HowItWorksSection from "../components/HowItWorksSection";
import NewCircleCard from "../components/NewCircleCard";
import Footer from "../containers/Footer";
import ReadyToCoOwnSection from "../containers/ReadyToCoOwnSection";

import RequestCircle from "../containers/RequestCircle";
import AppWrapper from "../containers/AppWrapper";

import LandingIhopaBuyBoat from '../containers/HomeBanners/LandingIhopaBuyBoat';
import LandingIhopaSellPartOfYourBoat from '../containers/HomeBanners/LandingIhopaSellPartOfYourBoat';
import LandingIhopaExistingOwnersBoat from '../containers/HomeBanners/LandingIhopaExistingOwnersBoat';
import LandingIhopaOthergardening from '../containers/HomeBanners/LandingIhopaOthergardening';
import LandingIhopaCoolstuff from '../containers/HomeBanners/LandingIhopaCoolstuff';
import LandingIhopaAutomower from '../containers/HomeBanners/LandingIhopaAutomower';

const mapPageToTabs=(params)=>{  //with this map you select tab from HomeFeaturedCircles
    const pages={
        "kopbat": "boats",
        "saljbaten": "boats",
        "andelsbat": "boats",
        "tradgardsredskap": "garden",
        "automower": "husqvarna",
        "fritid": "leisure"
    }
    return pages[params];
}

class HomeWithCustomBanner extends Component {
  constructor(props) {
    super(props);
    this.howItWorksRef = React.createRef();
    this.productsRef = React.createRef();
  }

  navigateToHowItWorks = () => {
    window.scrollTo(0, this.howItWorksRef.current.offsetTop - 50);
  };

  navigateToProducts = () => {
    window.scrollTo(0, this.productsRef.current.offsetTop - 56);
  };
     
  render() {
    const selected_tab = mapPageToTabs(this.props.custom_page);  
    return (
      <AppWrapper>
        <TopNav />
        {this.props.custom_page === 'tradgardsredskap' && <LandingIhopaOthergardening onHowItWorksClicked={this.navigateToHowItWorks}  goToProducts={this.navigateToProducts} />}
        {this.props.custom_page === 'automower' && <LandingIhopaAutomower onHowItWorksClicked={this.navigateToHowItWorks} goToProducts={this.navigateToProducts} />}        
        {this.props.custom_page === 'saljbaten' && <LandingIhopaSellPartOfYourBoat onHowItWorksClicked={this.navigateToHowItWorks} goToProducts={this.navigateToProducts} />}
        {this.props.custom_page === 'andelsbat' && <LandingIhopaExistingOwnersBoat onHowItWorksClicked={this.navigateToHowItWorks} goToProducts={this.navigateToProducts} />}
        {this.props.custom_page === 'kopbat' && <LandingIhopaBuyBoat onHowItWorksClicked={this.navigateToHowItWorks} goToProducts={this.navigateToProducts} />}
        {this.props.custom_page === 'fritid' && <LandingIhopaCoolstuff onHowItWorksClicked={this.navigateToHowItWorks} goToProducts={this.navigateToProducts} />}

        <div ref={this.productsRef} >
          <HomeFeaturedCircles queryParams={[selected_tab]}  />
        </div>
        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper align-center">
              <h1 className="bp3-heading hero-heading">
                <Translate value="home.havent_found_heading" />
              </h1>
              <div className="flex-top-space-between">
                <NewCircleCard />
                <RequestCircle />
              </div>
            </div>
          </div>
        </section>
        <div ref={this.howItWorksRef}>
          <HowItWorksSection />
        </div>

        <AdvantagesSection />

        <ReadyToCoOwnSection />
        <Footer />
      </AppWrapper>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  currentPage: state.router.location.pathname,
  queryParams: state.router.location.search.replace("?", "").split("&")
});
const mapDispatchToProps = dispatch => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeWithCustomBanner);
